var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstrela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.964,
    viewBox: "0 0 24 23.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "estrela",
    d: "M23.363,8.584,15.985,7.457,12.678.413a.781.781,0,0,0-1.357,0L8.015,7.457.637,8.584A.75.75,0,0,0,.214,9.849l5.36,5.494L4.307,23.11a.751.751,0,0,0,1.1.777L12,20.245l6.59,3.643a.75.75,0,0,0,1.1-.777l-1.267-7.767,5.36-5.494a.751.751,0,0,0-.423-1.266Z",
    transform: "translate(0 -0.018)",
    fill: "#ffc107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrela);
export default __webpack_public_path__ + "static/media/estrela.6aa9dae615f5cc31e9a9cac495e15b16.svg";
export { ForwardRef as ReactComponent };